import * as d3 from 'd3';

export default (el, data) => {
    const max = Math.max(...Object.values(data).map(d => d.value))
    
    const margin = { top: 10, right: 10, bottom: 50, left: 60 },
          width = 1200 - margin.left - margin.right,
          height = 200 - margin.top - margin.bottom

    // Calculate max bar width (1/4 of total width)
    const maxBarWidth = (width - margin.left - margin.right) / 5;
    
    // Updated scales for bar chart
    let xScale = d3.scaleBand()
          .domain(data.map((d, i) => i))
          .range([margin.left, width - margin.right])
          .padding(0.1)
    
    // Calculate actual bar width, capped at maxBarWidth
    const barWidth = Math.min(xScale.bandwidth(), maxBarWidth);
    
    let yScale = d3.scaleLinear()
          .domain([0, max])
          .range([height, margin.top])
          .clamp(true)

    const svg = d3.select(el)
          .append('svg')
          .attr('viewBox', `0 0 ${width} ${height}`)
          .attr('width', width + margin.left + margin.right)
          .attr('height', height + margin.top + margin.bottom)
          .append('g')

    // Create tooltip div
    const tooltip = d3.select(el)
          .append('div')
          .attr('class', 'tooltip')
    
    // Y-axis
    svg
        .append("g")
        .attr("class", "yAxis")
        .style("font-size", "14px")
        .style("color", "#999")
        .attr("transform", "translate(35,0)")
        .call(d3.axisLeft(yScale).tickValues([0, max]).tickSize(0))
        .select(".domain")
        .style("stroke", "#999");

    // X-axis with single "collections" label
    svg.append("g")
        .attr("class", "xAxis")
        .attr("transform", `translate(0, ${height})`)
        .call(d3.axisBottom(xScale).tickFormat("").tickSize(0))
        .select(".domain")
        .style("stroke", "#999");
        
    // Add collections label
    svg.append("text")
        .attr("x", (width) / 2)
        .attr("y", height + 30)
        .attr("class", "x-text")
        .attr("text-anchor", "middle")
        .style("font-size", "18px")
        .style("fill", "#999")
        .text("collections");

    // Create bars
    svg.selectAll('.bar')
        .data(data)
        .enter()
        .append('rect')
        .attr('class', 'bar')
        .attr('x', (d, i) => {
            // Center the bar within its band space
            const bandCenter = xScale(i) + xScale.bandwidth() / 2;
            return bandCenter - barWidth / 2;
        })
        .attr('y', (d) => yScale(d.value))
        .attr('width', barWidth)
        .attr('height', (d) => height - yScale(d.value))
        .attr('fill', '#EB131B')
        .style('cursor', 'pointer')
        .on('mouseover', function(event, d) {
            const bars = svg.selectAll('.bar').nodes();
            const i = bars.indexOf(this); 
            
            // Show tooltip
            tooltip.transition()
                .duration(200)
                .style('opacity', 1);
            
            // Get mouse position relative to the container
            const rect = el.getBoundingClientRect();
            let x, y;
            if (i <= bars.length / 2) {
                x = event.clientX - rect.left + 20;
                y = event.clientY - rect.top - 28;
            } else {
                x = event.clientX - rect.left - 150;
                y = event.clientY - rect.top - 28;
            }
            
            tooltip.html(`<strong>${d.label}</strong>Variants: ${d.value}`)
                .style('left', (x) + 'px')
                .style('top', (y) + 'px');
            
            // Highlight the bar
            d3.select(this)
                .transition()
                .duration(100)
                .attr('fill', '#FF4444'); // Slightly lighter red for hover
        })
        .on('mouseout', function(event, d) {
            // Hide tooltip
            tooltip.transition()
                .duration(200)
                .style('opacity', 0);
            
            // Reset bar appearance
            d3.select(this)
                .transition()
                .duration(100)
                .attr('fill', '#EB131B');
        });
}